// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"feeb68ca","226":"aa165b54"}[chunkId] + ".chunk.css";
};